{
  "el": {
    "published": {
      "labels": {
        "notPublished": "Μη δημοσιευμένο",
        "publishedCustomer": "Δημοσιευμένο για πελάτες",
        "publishedCustomerPartners": "Δημοσιευμένο για πελάτες και συνεργάτες",
        "publishedPartners": "Δημοσιευμένο για συνεργάτες"
      },
      "publish_mode": {
        "inherit": "Ακολούθηση προτύπου",
        "inherit_info": "Διατηρεί την κατάσταση δημοσίευσης κάθε στοιχείου από το πρότυπο",
        "publish": "Δημοσίευση στους πελάτες",
        "publish_info": "Οι πελάτες μπορούν να τα δουν αμέσως",
        "title": "Δημοσίευση",
        "unpublished": "Δημιουργία χωρίς δημοσίευση",
        "unpublished_info": "Κρυφά από τους πελάτες μέχρι να τα δημοσιεύσεις"
      }
    }
  }
}
